/*jshint esversion: 6 */

try {
    Typekit.load({
        async: true
    });
} catch (e) {}


// Add Home Link to Breadcrumbs
const homeBreadcrumb = document.getElementById('home-breadcrumb');
const breadcrumbTarget = document.querySelector('[itemprop="breadcrumb"] > span');

document.addEventListener('DOMContentLoaded', () => {
    if (breadcrumbTarget && homeBreadcrumb) {
        breadcrumbTarget.prepend(homeBreadcrumb);
    }
});


// Move Eyebrow content on breakpoint
const breakpoint = Number(getComputedStyle(document.body).getPropertyValue('--bs-breakpoint-lg').replace('rem','')*16);

function moveContent() {
    const desktopTarget = document.querySelector('#eyebrow-desktop-target > div');
    const mobileTarget = document.getElementById('eyebrow-mobile-target');
    const contentToMove = document.getElementById('eyebrow-content');

    if(contentToMove) {
        if (window.innerWidth >= breakpoint) { 
            desktopTarget.appendChild(contentToMove);
        } else {
            mobileTarget.appendChild(contentToMove);
        }
    }
}

window.addEventListener('DOMContentLoaded', () => {
    // Initial execution on page load
    moveContent();

    // Event listener for window resize
    window.addEventListener('resize', moveContent);
});

// Hide side menu when there is nothing on the main column
const mainColumn = document.getElementById('main-column');
const navSideMenu = document.getElementById('nav-side-menu');

if (mainColumn && navSideMenu) {
    const hasDnnModule = mainColumn.querySelector('.DnnModule') == null;
    console.log(hasDnnModule);
    if (hasDnnModule) {
        navSideMenu.classList.add('d-none');
    }
}